import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import { theme } from "twConfig";

Vue.use(VueProgressBar, {
  color: theme.colors["fc-disable"],
  failedColor: theme.colors["fc-error"],
  thickness: "0.1875rem",
});
